import axios from 'axios';
import api from '../common/api';

var token = localStorage.getItem('userToken')

export const post_request = (url, params) => {
	return axios
				.post(url,
				{
					params
				},
	    		{
    				headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}
    			}
				)
				.then(res => {
					return res
				})
				.catch(err =>{
					return err
				})
}

export const get_request = async (url) => {
	if (!token)
		token =  localStorage.getItem('userToken')

	return await axios
				.get(url,
				{
    				headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}
				})
				.then(res => {
					return res
				})
				.catch(err =>{
					var error = {}
					var promise = new Promise(function(resolve, reject) {
						resolve(err.response.data);
					  });
	
					if (err.response) {
						error.status = err.response.status
						error.data = err.response.data
					}					
					return error
				})
}

export const delete_request = (url, params) =>{
	return axios.delete(url,
			{ headers: {"Authorization" : `Bearer ${token}`}},
			params
			)
			.then(res => {
				return res
			})
			.catch(err =>{
				return err
	})
}
